import React from 'react';
import './Footer.scss';
import { useStaticQuery, graphql, Link } from "gatsby"
import PublicisLogo from '../../assets/images/publicis-logo.png'
//import { useState } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

const Footer = ({}) => {

  const dataFooter = useStaticQuery(graphql`
    {
      contentfulFooter {
        footerPageLinks {
          linkUrl
          text
          external
        }
        footerSocialLinks {
          linkUrl
          text
          external
        }
        logo {
          gatsbyImageData
          title
        }
        copyrightText
      }
    }
  `)

  //const [openSignUp, setOpenSignUp] = useState(false);

  return (
    <footer id="footer">
      <div className="footer-container">
        <div className="row">
          <div className="footer-logo col-lg-3 col-md-3 ">
            <Link to={'/'}> 
              <GatsbyImage image={dataFooter?.contentfulFooter?.logo?.gatsbyImageData} className="logo-desk" alt={dataFooter?.contentfulFooter?.logo?.title}/>
            </Link>
            <Link to={'/creations'}> 
              <GatsbyImage image={dataFooter?.contentfulFooter?.logo?.gatsbyImageData} className="logo-mob" alt={dataFooter?.contentfulFooter?.logo?.title}/>
            </Link>
          </div>
          <div className="mentions col-lg-2 col-sm">
            <ul>
              <li dangerouslySetInnerHTML={ {  __html: dataFooter?.contentfulFooter?.copyrightText}} />
              {
                dataFooter?.contentfulFooter?.footerPageLinks.map((link, indexCP) => (
                  <li key={indexCP}>
                    {
                      link.external ? ( 
                        <a href={link.linkUrl} target="_blank" rel="noreferrer">{link.text}</a>
                      ) : 
                      <Link to={link.linkUrl}>{link.text}</Link>
                    }
                    
                  </li>
                ))
              }
              <li>
                <button id="ot-sdk-btn" className="ot-sdk-show-settings">Cookie Settings</button>
              </li>
            </ul>
          </div>
          <div className="footer-contact col-lg-3 col-sm">
            <ul>
              {
                dataFooter?.contentfulFooter?.footerSocialLinks.map((link, indexLink) => (
                  <li key={indexLink}>
                    {
                      link.external ? ( 
                        <a href={link.linkUrl} target="_blank" rel="noreferrer">{link.text}</a>
                      ) : 
                      <Link to={link.linkUrl}>{link.text}</Link>
                    }
                  </li>
                ))
              }
            </ul>
          </div>

          {/* <div className="signup-box col-lg-4 col-sm-12 d-flex" onClick={(e) => setOpenSignUp(true)}>
            <div className="sib-form" style={{ textAlign: 'center', padding: '0'}}>
              <div id="sib-form-container" className="sib-form-container">
                  <div id="error-message" className="sib-form-message-panel" style={{color: '#661d1d', backgroundColor: '#ffeded', borderColor: '#ff4949', maxWidth: '540px'}}>
                    <div className="sib-form-message-panel__text sib-form-message-panel__text--center">
                        <svg viewBox="0 0 512 512" className="sib-icon sib-notification__icon">
                          <path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z" />
                        </svg>
                        <span className="sib-form-message-panel__inner-text">
                        Your subscription could not be saved. Please try again.
                        </span>
                    </div>
                  </div>
                  <div></div>
                  <div id="success-message" className="sib-form-message-panel" style={{color: '#085229', backgroundColor : '#e7faf0', borderColor: '#13ce66', maxWidth: '540px'}}>
                    <div className="sib-form-message-panel__text sib-form-message-panel__text--center">
                        <svg viewBox="0 0 512 512" className="sib-icon sib-notification__icon">
                          <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z" />
                        </svg>
                        <span className="sib-form-message-panel__inner-text">
                        Your subscription has been successful.
                        </span>
                    </div>
                  </div>
                  <div></div>
                  <div id="sib-container" className="sib-container--large sib-container--vertical" style={{textAlign: 'center', backgroundColor: 'transparent', padding: '0'}}>
                    <form id="sib-form" method="POST" noValidate action="https://8e509f9a.sibforms.com/serve/MUIEAOTRkUFzBWQZg3FDZfUXxxP_C0E4ecPU70fYa5eCSTJg5u0-BrM7oKAoxkapbWnWIpVgzPzBYpaYbkE7Bt5h5m5ebGcP1Dd-9oLPwoNO5OaajVm4O9ebuCQVbnXvImYDaDq1HFx55nOTM1fClqGAiB0ZIWbeDFFzdjfg_g9YwjoJJ0nVZDtvvH8EVbjc2afQIS-iqn0ziD1G" data-type="subscription">
                        <div className="sib-form-block">
                          <span>Newsletter Publicis EtNous</span>
                        </div>
                        <div className="sib-input sib-form-block">
                          <div className="form__entry entry_block">
                              <div className="form__label-row ">
                                <div className="entry__field"  style={{ background:'transparent' }}>
                                    <input className="input label_1" type="text" id="EMAIL" name="EMAIL" autoComplete="off" placeholder="E-MAIL" data-required="true" required />
                                </div>
                                <span className="floating_label">EMAIL</span>
                              </div>
                              <label className="entry__error entry__error--primary">
                              </label>
                          </div>
                        </div>
                        <div className="sib-input sib-form-block">
                          <div className="form__entry entry_block">
                              <div className="form__label-row ">
                                <div className="entry__field" style={{ background:'transparent' }}>
                                    <input className="input label_2" maxLength="200" type="text" id="FIRSTNAME" name="FIRSTNAME" autoComplete="off" placeholder="NAME" data-required="true" required />
                                </div>
                                <span className="floating_label_2">NAME</span>
                              </div>
                              <label className="entry__error entry__error--primary">
                              </label>
                          </div>
                        </div>
                        <div className={`submit-section ${openSignUp? 'open' : ''}`}>
                          <div style={{ margin: '15px 24px', width: '100%' }}>
                              <div className="sib-optin sib-form-block">
                                <div className="form__entry entry_mcq">
                                    <div className="form__label-row ">
                                      <div className="entry__choice">
                                          <label>
                                            <input type="checkbox" className="input_replaced" value="1" id="OPT_IN" name="OPT_IN" />
                                            <span className="checkbox checkbox_tick_positive"></span>
                                            <span>
                                                <p>SUBSCRIBE TO RECEIVE NEWSLETTER</p>
                                            </span>
                                          </label>
                                      </div>
                                    </div>
                                    <label className="entry__error entry__error--primary">
                                    </label>
                                </div>
                              </div>
                          </div>
                          <div style={{margin: '15px 24px 31%', width: '100%'}} id="scrollto">
                              <div className="sib-optin sib-form-block" data-required="true">
                                <div className="form__entry entry_mcq">
                                    <div className="form__label-row ">
                                      <div className="entry__choice">
                                          <label>
                                            <input type="checkbox" className="input_replaced" value="1" id="APPROVAL" name="APPROVAL" required />
                                            <span className="checkbox checkbox_tick_positive"
                                                ></span>
                                            <span>
                                                <p>I HAVE READ, UNDERSTAND AND ACCEPT THE GENERAL CONDITIONS OF USE AND THE PERSONAL DATA PRIVACY POLICY</p>
                                                <span data-required="*" style={{ display: 'inline' }} className="entry__label entry__label_optin"></span>
                                            </span>
                                          </label>
                                      </div>
                                    </div>
                                    <label className="entry__error entry__error--primary secondary">
                                    </label>
                                </div>
                              </div>
                          </div>
                          <div className="sib-form-block" style={{ textAlign: 'center' }}>
                              <button className="sib-form-block__button sib-form-block__button-with-loader" form="sib-form" type="submit">
                                <svg className="icon clickable__icon progress-indicator__icon sib-hide-loader-icon" viewBox="0 0 512 512">
                                    <path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z" />
                                </svg>
                                SUBMIT
                              </button>
                          </div>
                        </div>
                        <input type="text" name="email_address_check" value="" className="input--hidden"/>
                        <input type="hidden" name="locale" value="en"/>
                    </form>
                  </div>
              </div>
            </div>
          </div> */}
          
        </div>
        <div className="footer-logo-mob col-lg-12 col-sm-12 ">
          <Link to={'/'}>
            <img src={PublicisLogo} className="" alt="footer-logo" />
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

